<template>

    <div class="c-form_switch">
        <label class="c-form_switch__container" :class=" { 'c-form_switch__container--error' : getError }">
            <div class="c-form_switch__slider">
                <input
                    v-model="newValue"
                    type="checkbox"
                    :value="nativeValue"
                    :name="inputName"
                    :true-value="trueValue"
                    :false-value="falseValue"
                    :disabled="disabled">
                <span class="c-form_switch__pivot"></span>
            </div>
            <span class="c-form_switch__label">{{ label }}</span>
        </label>
        <form-error-msg :msg="getError"></form-error-msg>
    </div>

</template>


<script>

import FormErrorMsg from './FormErrorMsg'

export default {

    name: 'FormSwitch',

    $_veeValidate: {
        name() {
            return this.inputName
        },
        value() {
            return this.value
        },
    },

    props: {
        value: [String, Number, Boolean, Function, Object, Array, Symbol],
        nativeValue: [String, Number, Boolean, Function, Object, Array, Symbol],
        trueValue: {
            type: [String, Number, Boolean, Function, Object, Array, Symbol],
            default: true
        },
        falseValue: {
            type: [String, Number, Boolean, Function, Object, Array, Symbol],
            default: false
        },
        label: String,
        name: String,
        type: {
            type: String,
            default: "text"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            required: false
        },
    },

    data() {
        return {
            newValue: this.value,
        }
    },

    computed: {
        inputName() {
            var tmp_name = this.$vnode.data.model.expression.split('.')
            var name = ''

            if (tmp_name.length > 1)
                name = tmp_name[tmp_name.length - 1]
            else
                name = tmp_name[0]

            return this.name || name
        },
        getError() {
            var err = this.errors.items.filter((error) => {
                return (error.field === this.inputName)
            })

            if (err.length)
                return err[0].msg
            else
                return null
        }
    },

    watch: {
        value(value) {
            this.newValue = value
        },
        newValue(value) {
            this.$emit('input', value)
        }
    },

    components: {
        FormErrorMsg
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_switch {
    width: 100%;
    margin-bottom: 1rem;

    &__container {
        display: flex;
        align-items: center;
        cursor: pointer;
        user-drag: none;

        user-select: none;
    }

    &__slider {
        position: relative;
        display: inline-block;
        flex-shrink: 0;

        width: 36px;
        height: 22px;
        margin-right: 1rem;
    }
    &__pivot {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        border-radius: 15px;
        -webkit-transition: .2s;
        transition: .2s;

        &:before {
            position: absolute;
            content: "";
            height: 18px;
            width: 18px;
            left: 2px;
            bottom: 2px;
            background-color: white;
            border-radius: 50%;
            -webkit-transition: .2s;
            transition: .2s;
        }
    }
    input {
        opacity: 0;
    }
    input:checked + &__pivot {
        background-color: $c-primary;
    }
    input:focus + &__pivot {
        box-shadow: inset 0 0 0 2px $c-primary;
    }
    input:checked + &__pivot:before {
        transform: translateX(14px);
    }
    &__label {
        font-size: 0.8rem;
        text-transform: uppercase;
        letter-spacing: 0.08rem;
    }
}

</style>
